import { useTranslation } from "react-i18next";
import type { ChartType, TimeRange } from "../types";
import { getTimeRanges } from "../constants";
import { Button } from "../../button";

export interface ChartControlsProps {
  chartType: ChartType;
  onChartTypeChange: (type: ChartType) => void;
  timeRange: TimeRange;
  onTimeRangeChange: (range: TimeRange) => void;
}

export const ChartControls = ({ chartType, onChartTypeChange, timeRange, onTimeRangeChange }: ChartControlsProps) => {
  const { t } = useTranslation("ui");

  return (
    <div data-slot="chart-controls" className="flex items-center justify-between mb-4">
      {/* Chart type toggle */}
      <div className="flex items-center gap-1 p-0.5 bg-gray-100 dark:bg-gray-800 rounded-[10px]">
        <Button
          variant={chartType === "line" ? "chip-active" : "chip"}
          onClick={() => onChartTypeChange("line")}
          className="h-7 px-3 text-xs"
        >
          {t("Line")}
        </Button>
        <Button
          variant={chartType === "bar" ? "chip-active" : "chip"}
          onClick={() => onChartTypeChange("bar")}
          className="h-7 px-3 text-xs"
        >
          {t("Bar")}
        </Button>
      </div>

      {/* Time range chips */}
      <div className="flex items-center gap-1">
        {getTimeRanges().map(({ key, label }) => (
          <Button
            key={key}
            variant={timeRange === key ? "chip-active" : "chip"}
            onClick={() => onTimeRangeChange(key)}
            className="h-7 px-2.5 text-xs"
          >
            {label}
          </Button>
        ))}
      </div>
    </div>
  );
};
